import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, useTheme } from "@mui/material";
import { useContext } from "react";
import { UpdateOrderDeliveryPickupModalContext, initialNewAddressData, } from "../../../../Account/useUpdateOrderDeliveryModal/deliveryModalUtils/UpdateOrderDeliveryPickupModalContext";
import Stack from "@mui/material/Stack";
import { ExtraSmallFab } from "../../Buttons/ExtraSmallFAB";
import { DSRM_Actions } from "../DSRM_Components/DSRM_Actions";
import { DSRM_Content } from "../DSRM_Components/DSRM_Content";
import { DSRM_Title } from "../DSRM_Components/DSRM_Title";
import { useDeliveryScheduleRemappingModal } from "../hooks/useDeliveryScheduleRemappingModal";
/**
 * This modal is used on the orders, subscriptions and addresses pages. It does not use the Modal context.
 * @param param0
 * @returns
 */
export const DeliveryScheduleRemappingModal = ({ showModal, setShowModal, orderNumber, currentAddressCardData, orderId, remappingModalTitle, additionalCloseModalFunction, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    const { setNewAddressData } = useContext(UpdateOrderDeliveryPickupModalContext);
    const { orderData } = useDeliveryScheduleRemappingModal(orderId);
    const titleStyles = {
        position: `sticky`,
        top: "0px",
        backgroundColor: theme.palette.background.paper,
        zIndex: "1",
    };
    const onClose = () => {
        setNewAddressData(initialNewAddressData);
        if (additionalCloseModalFunction)
            additionalCloseModalFunction();
        setShowModal((prev) => !prev);
    };
    return (_jsxs(Dialog, Object.assign({ maxWidth: "md", fullWidth: true, fullScreen: isMobile, open: showModal, onClose: onClose }, { children: [_jsx(DialogTitle, Object.assign({ style: Object.assign({}, titleStyles) }, { children: _jsxs(Stack, Object.assign({ direction: "row", justifyContent: "space-between", alignItems: "center" }, { children: [_jsx(DSRM_Title, { remappingModalTitle: remappingModalTitle }), _jsx(ExtraSmallFab, { icon: CloseIcon, "aria-label": "close", onClick: onClose })] })) })), _jsx(DialogContent, { children: _jsx(DSRM_Content, Object.assign({}, { orderData, orderNumber, currentAddressCardData })) }), _jsx(DialogActions, { children: _jsx(DSRM_Actions, { onClose: onClose }) })] })));
};
